const validatePage3 = (values) => {
    const errors = {}
    if (!values.formación) {
        errors.formación = 'Este campo es requerido, indique su nivel educativo'
    }
    // if (!values.formaciónAreaArtística) {
    //     errors.formaciónAreaArtística = 'Este campo es requerido, indique su formación artística'
    // }
    if (values.formaciónAreaArtística?.id === 96) {
        if (!values.otraFormaciónArtística) {
            errors.otraFormaciónArtística = "Este campo es requerido, indique cuál otra actividad"
        }
    }
      if (!values.actividadArtística) {
        errors.actividadArtística = 'Este campo es requerido, indique su principal actividad'
    }
    if (values.actividadArtística?.id === 96) {
        if (!values.otraActividad) {
            errors.otraActividad = "Este campo es requerido, indique cuál otra actividad"
        }
    }
    // No existe 'Ninguna' en el listado
    if(values.actividadArtística !== 'Ninguna'){
        if (!values.tiempoActividadAños) {
            errors.tiempoActividadAños = 'Este campo es requerido, indique el tiempo dedicado a esta actividad'
        }
        if (parseInt(values.tiempoActividadAños) > 120 ) {
            errors.tiempoActividadAños = 'Los años dedicados a la actividad no pueden superar los 120 años.'
        }
        if (!values.tiempoActividadMeses) {
            errors.tiempoActividadMeses = 'Este campo es requerido, indique el tiempo dedicado a esta actividad'
        }
        if (parseInt(values.tiempoActividadMeses) >= 12 ) {
            errors.tiempoActividadMeses = 'El tiempo dedicado a la actividad en meses no puede ser mayor a 11.'
        }

        if (!values.desempeñaActividad) {
            errors.desempeñaActividad = 'Este campo es requerido, indique si desempeña esta actividad'
        }
        if (values.desempeñaActividad?.id === 31) {
            if (!values.cualDesempeña) {
                errors.cualDesempeña = "Este campo es requerido, indique que actividad desempeña actualmente"
            }
        }
    }
    return errors
}

export default validatePage3;